import * as React from 'react'
import {DataGrid} from '@mui/x-data-grid'
import {usePhoneGridColumns} from '../theme/responsive.config'

// The MUI DataGrid, with columns that scroll sideways on phones instead of being squeezed (see
// usePhoneGridColumns). Use it wherever DataGrid is used directly; ProzoDataGrid already does.
const ResponsiveDataGrid = React.forwardRef(function ResponsiveDataGrid({columns, ...props}, ref) {
  return <DataGrid ref={ref} columns={usePhoneGridColumns(columns)} {...props} />
})

export default ResponsiveDataGrid
